import React from 'react';
import Card from 'components/common/Card';
import LoadingSpinner from 'components/LoadingSpinner';
import ErrorDisplay from 'components/ErrorDisplay';

import {
  Button,
  Terms,
  List,
  Item,
  Header,
  AppIcon,
  IconContain,
  SearchLightLogo,
  SearchLightText
} from './Styled';

export const OauthCard = ({ baseUrl, apiUrl, hasClient, error, loading, qs, user, client }) => (
  <Card.Content>

    <Header>
      <SearchLightLogo />
      <SearchLightText />
    </Header>

    {error && <ErrorDisplay message={error} />}

    {loading && 
      <div style={{ margin: '1rem 0rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <LoadingSpinner /> Loading details
      </div>
    }

    {!loading && hasClient &&
      <div style={{ padding: '1rem'}}>
        <p style={{ marginTop: '0', marginBottom: '1rem' }}>
          Hi <span style={{ fontWeight: 500 }}>{user.name}</span> (<span style={{ color: '#9CA3AF' }}>{user.email}</span>),
        </p>
        
        <IconContain>
          <h2 style={{ textTransform: 'capitalize', color: '#374151' }}><span style={{ fontWeight: 400 }}>Connect</span> {client.name}</h2>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <AppIcon src={`${baseUrl}/img/${client.identifier}-logo.png`} />
          </div>
          <p style={{ fontSize: '0.875rem' }}><span style={{ textTransform: 'capitalize' }}>{client.name}</span> would like to connect with your Searchlight Technology account</p>
        </IconContain>

        <p style={{ fontWeight: 500 }}>Important Information</p>

        <p style={{ color: '#6B7280', fontSize: '0.875rem' }}>
          This will give <span style={{ textTransform: 'capitalize' }}>{client.name}</span> access to your account and the ability to:
        </p>

        <List>
          <Item>
            <svg style={{ marginRight: '0.5rem', height: '1.5rem', width: '1.5rem', color: '#9CA3AF' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            View orders & history
          </Item>
          <Item>
            <svg style={{ marginRight: '0.5rem', height: '1.5rem', width: '1.5rem', color: '#9CA3AF' }} xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Create and update orders
          </Item>
          <Item>
            <svg style={{ marginRight: '0.5rem', height: '1.5rem', width: '1.5rem', color: '#9CA3AF' }} xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
            </svg>
            Create charges and authorise payments
          </Item>
        </List>

        <form
          action={`${apiUrl}/oauth2/authorize`}
          method={'POST'}
        >
          <input type="hidden" name="transaction_id" value={client.transactionId} /> 
          <Button type="submit">Authorise</Button>
        </form>

        <Terms>By clicking Authorise you allow {client.name} to use your information in accordance with their respective terms of service and privacy polices.</Terms>
      </div>
    }
  </Card.Content>
)

export default OauthCard;
